import { findSelfiesByAttendeeId, deleteSelfie } from '../../../packages/src/api/index.js';
import { hideLoading, isMobile, showLoading } from './utils-module.js';
import { uploadSelfieImage } from './uploadPhotosUtil.js';
import { initModeSwitcher } from './modeSwitcher.js';
import { initSelect } from './select.js';
import { initGalleryViewController } from './imageList.js';
import { initActionPanel } from './actionPanel.js';
import { initSelectedPanel } from './panel-selected.js';
import LANG from '../lang/prop_en.js';
import * as photoDC from './photoDS.js';
import multiAccounts from './multiAccounts/index.ts';

const modeSwitcher = initModeSwitcher();
const selectImage = initSelect();
const galleryVC = initGalleryViewController({ isShowDownloadBtn: false });
const actionPanel = initActionPanel();
const selectedPanel = initSelectedPanel();
const emptyContent = initEmptyContent();
const addSelfieBtn = initAddSelfieButton();

(function init() {
  findSelfiesByAttendeeId(multiAccounts.getCurrentAccount().attendeeUid).then(({ result: selfies }) => {
    if (selfies.length === 0) {
      emptyContent.show();
    } else {
      emptyContent.hide();
      if (selfies.length < 5) {
        addSelfieBtn.show();
      }
      initGallery(selfies);
    }

    initAddSelfies();
  });
})();

function initEmptyContent() {
  const $elem = document.querySelector('.empty-content');

  return {
    show,
    hide,
  };

  function show() {
    $elem.style.display = 'flex';
  }

  function hide() {
    $elem.style.display = 'none';
  }
}

function initAddSelfieButton() {
  const $elem = document.querySelector('.float-button');

  return {
    show,
    hide,
  };

  function show() {
    $elem.style.display = 'inline-flex';
  }

  function hide() {
    $elem.style.display = 'none';
  }
}

function initGallery(selfies) {
  galleryVC.render(selfies.map(photoDC.viewModel));
  actionPanel.render([{ id: 'delete', iconName: 'delete', text: 'Delete' }]);

  if (isMobile()) {
    modeSwitcher.switchToDefaultMode();

    galleryVC.onClick(({ id }) => {
      if (modeSwitcher.isSelectMode()) {
        selectImage.toggle(id);
      }
    });

    galleryVC.onLongTouch(({ id }) => {
      if (modeSwitcher.isDefaultMode()) {
        modeSwitcher.switchToSelect();
        selectImage.select(id);
      }
    });

    modeSwitcher.onSelectMode(galleryVC.enableSelect);
    modeSwitcher.onSelectMode(actionPanel.show);
    modeSwitcher.onSelectMode(selectedPanel.show);

    modeSwitcher.onDefaultMode(galleryVC.disableSelect);
    modeSwitcher.onDefaultMode(actionPanel.hide);
    modeSwitcher.onDefaultMode(selectedPanel.hide);

    selectImage.onUpdate((photos) => {
      if (photos.size === 0) {
        modeSwitcher.switchToDefaultMode();
      }
    });
  } else {
    galleryVC.enableSelect();
    galleryVC.onClick(({ id }) => selectImage.toggle(id));

    selectImage.onUpdate((photos) => {
      if (photos.size === 0) {
        actionPanel.hide();
        selectedPanel.hide();
      } else {
        actionPanel.show();
        selectedPanel.show();
      }
    });
  }

  selectImage.onSelect(galleryVC.select);
  selectImage.onUnselect(galleryVC.unselect);
  selectImage.onUnselectAll(galleryVC.unselectAll);

  selectImage.onUpdate((photos) => {
    if (photos.size === 0) {
      actionPanel.disableBtn('delete');
    } else {
      actionPanel.enableBtn('delete');
    }
  });

  selectImage.onUpdate((photos) => {
    selectedPanel.updateAmountOfSelect(photos.size);
  });

  actionPanel.onClickBtn('delete', () => {
    if (!actionPanel.isDisabledBtn('delete')) {
      removeSelfie(selfies).then(() => window.location.reload());
    }
  });

  selectedPanel.onClickClearBtn(selectImage.unselectAll);
}

function removeSelfie(selfies) {
  const attendeeId = multiAccounts.getCurrentAccount().attendeeUid;
  const selectedPhotoUid = selfies.filter(photoDC.includesById(selectImage.array())).map((photo) => photo.uid);
  return Promise.all(selectedPhotoUid.map((photoUId) => deleteSelfie(attendeeId, photoUId)));
}

function initAddSelfies() {
  const $triggerUploadPhoto = document.querySelector('#selfies-uploader');

  const $elements = document.querySelectorAll('.emit-selfies-uploader');
  Array.from($elements).forEach(($element) => {
    $element.addEventListener('click', () => {
      $triggerUploadPhoto.click();
    });
  });

  $triggerUploadPhoto.addEventListener('change', function () {
    showLoading();
    Promise.all(Array.from(this.files).map((file) => uploadSelfieImage(file)))
      .then(() => {
        window.location.reload();
      })
      .catch((e) => {
        if (e.message === LANG.unsupported_pic_format) {
          alert(LANG.unsupported_pic_format);
        }
        hideLoading();
        console.error(e);
      });
  });
}
